import type { ReactNode } from 'react'
import type { SocToken } from '@/styles/tokens'

/** A square status chip: token ink on a translucent wash of the same token. */
export function Badge({ tone = 'ink-mute', children, className = '' }: { tone?: SocToken; children: ReactNode; className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-[3px] font-title text-[10px] font-medium tracking-[0.2em] uppercase ${className}`}
      style={{
        color: `var(--soc-${tone})`,
        background: `color-mix(in srgb, var(--soc-${tone}) 12%, transparent)`,
        boxShadow: `inset 0 0 0 1px color-mix(in srgb, var(--soc-${tone}) 45%, transparent)`,
      }}
    >
      {children}
    </span>
  )
}
